function isSchoolLearningHubRestricted(school) {
  if (!school) return false
  // Set from current-year detail on school_portal API; survives survey-year detail reloads.
  if (school.learningHubRestrictAccess === true) return true
  if (school.learningHubRestrictAccess === false) return false
  return school.detail?.restrictAccess === true
}

// Returns true if ANY of the user's school employments points at a
// school flagged as Learning-Hub-restricted. Mirrors the server-side
// LearningHub::AccessPolicy#school_employer_restricted? behavior so the
// UI and the API agree before the currently-selected school's payload
// has finished loading (otherwise restricted users see a flash of LH
// content before the redirect fires).
function isAnySchoolEmploymentRestricted(userDetails) {
  const employments = userDetails?.employments
  if (!Array.isArray(employments) || employments.length === 0) return false
  return employments.some((employment) => {
    if (employment?.employableType !== 'School') return false
    return isSchoolLearningHubRestricted(employment?.employable)
  })
}

function isLearningHubEnabled(userDetails, school = null) {
  if (userDetails?.learningHubAccess !== true) return false
  if (userDetails?.learningHub !== true) return false
  if (school && isSchoolLearningHubRestricted(school)) return false
  if (isAnySchoolEmploymentRestricted(userDetails)) return false
  return true
}

export default isLearningHubEnabled
export { isSchoolLearningHubRestricted, isAnySchoolEmploymentRestricted }
